<template>
  <div>
    <wrapper-preview-category customClass="section-preview_lk">
      <div v-html="pathTooltip"></div>
    </wrapper-preview-category>
    <wrapper-preview-category customClass="section-preview_lk">
      <wrapper-collapse custom-class="collapse-mb-0" initial-open title="">
        <p class="mb-1">
          Ввод вступительных испытаний(ВИ) осуществляется построчно для каждого отдельно испытания;
        </p>
        <p class="mb-1">
          Если нужно ввести ВИ по выбору, при добавлении выберите несколько предметов и укажите
          минимальные баллы по ним. В таблице они будут отображаться в одной строке через знак "/"(в
          значении «или»);
        </p>
        <p class="mb-1">Приоритетность ВИ можно менять стрелочками в первом столбце.</p>
        <p>
          В рамках "Дополнительных ВИ" необходимо внести перечень дополнительных профессиональных
          вступительных испытаний (например: творческой и (или) профессиональной направленности (для
          МГУ и СПбГУ, в том числе - дополнительные вступительные испытания профильной
          направленности, предусмотренные Федеральным законом от 10 октября 2009 г. №259-ФЗ)).
        </p>
        <p>
          Внесение наименований ВИ, проводимых образовательной организацией самостоятельно, для
          выпускников СПО - не требуется.
        </p>
      </wrapper-collapse>
    </wrapper-preview-category>
    <wrapper-preview-category customClass="section-preview_lk">
      <v-btn class="blue__v-btn mb-3" @click="$router.go(-1)">Назад</v-btn>
      <grid-table
        v-if="tableHeaders.massive && tableHeaders.massive.length > 0"
        :paint-background="paintBackgroundProp"
        :data-rows="tableData.data"
        :headers="tableHeaders.massive"
        :headers-for-rows="tableHeaders.massive"
        :loading-data="tableData.loading || getSprDataLoading.predmets"
        :num-cols="tableHeaders.countCells"
        max-table-height="700px">
        <template #header-actions="{ row }">
          <div class="d-flex align-center justify-center flex-row">
            <v-btn
              :disabled="isBlocked || (getSelectedYear === '2023')"
              @click.stop="openDialog('action', row)"
              class="blue__v-btn">
              Добавить строку
            </v-btn>
          </div>
        </template>
        <template #sortOrder="{ row }">
          <div class="d-flex align-center justify-center flex-row">
            <span>{{ row.sortOrder }}</span>
            <v-btn

              :disabled="isBlocked"
              @click.stop="changeOrder('up', row)"
              icon>
              <v-icon color="primary" size="24">mdi-chevron-up</v-icon>
            </v-btn>
            <v-btn
              v-if="row.sortOrder !== 1"
              :disabled="isBlocked"
              @click.stop="changeOrder('down', row)"
              icon>
              <v-icon color="primary" size="24">mdi-chevron-down</v-icon>
            </v-btn>
          </div>
        </template>
        <template #actions="{ row }">
          <div class="d-flex align-center justify-center flex-row">
            <v-btn
              :disabled="isBlocked"
              :loading="tableData.change.id === row.id && tableData.change.value"
              @click.stop="openDialog('edit', row)"
              icon>
              <v-icon color="primary" size="24">mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              :disabled="isBlocked"
              :loading="tableData.change.id === row.id && tableData.change.value"
              @click.stop="deleteOrgTableData(row)"
              icon>
              <v-icon color="primary" size="24">mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
      </grid-table>
    </wrapper-preview-category>
    <universal-dialog
      :data-for-dialog="tableData.editRow"
      :headers-for-dialog="tableHeaders.dialog"
      :loading="tableData.change.value"
      :spr-data="sprDataForDialog"
      @closing-dialog="closeDialog()"
      @fetch-new-data="changeOrgTableData($event)"
      @dialog-emit="dialogEmits($event)"
      id-name="id"
      ref="dialog">
      <template #title>
        <h2>Добавить запись</h2>
      </template>
      <template #actions="{ close, sendData, loading, validSolo }">
        <div class="d-flex flex-row align-center justify-space-between" style="width: 100%">
          <v-btn @click="close()" class="white__v-btn"> Отменить </v-btn>
          <v-btn :disabled="!validSolo" :loading="loading" @click="sendData()" class="blue__v-btn">
            Сохранить
          </v-btn>
        </div>
      </template>
    </universal-dialog>
  </div>
</template>

<script>
  import Utils from '@/services/utils';
  import { mapGetters, mapActions } from 'vuex';
  import request from '@/services/request';
  import GridTable from '@/components/table/GridTable';
  import UniversalDialog from '@/components/dialog/UniversalDialog';
  import WrapperPreviewCategory from '@/components/cards/WrapperPreviewCategory';
  import EgeTableHeaders from '@/newApplication/views/tables/EgeTableHeaders';
  import WrapperCollapse from '@/components/cards/WrapperCollapse';
  import {
    changeOrgTableDataEge,
    deleteOrgTableDataEge,
    getOrgTableDataEge,
  } from '@/API/tables/ege';

  export default {
    name: 'EgeTable',
    components: { WrapperCollapse, GridTable, UniversalDialog, WrapperPreviewCategory },
    data: () => ({
      tableHeaders: [],
      tableData: {
        loading: false,
        change: { value: false, id: null },
        error: null,
        editRow: null,
        data: [],
      },
      sprPredmet: [],
      minValue: 0,
      pathTooltip: '',
      selectedYear: '2024',
    }),
    computed: {
      ...mapGetters('keycloak', {
        getFakeUser: 'getFakeUser',
        getUserRoles: 'getUserRoles',
        getUserAccessToken: 'getUserAccessToken',
        getUser: 'getUser',
      }),
      ...mapGetters('spr', {
        getSprData: 'getSprData',
        getSprDataLoading: 'getSprDataLoading',
        getSprDataError: 'getSprDataError',
      }),
      ...mapGetters('checkFilled', { getBlock: 'getBlockStatus' }),
      ...mapGetters({ getSelectedYear: 'selectedYear' }),
      getId() {
        if (this.getFakeUser) return this.getFakeUser.id;
        return this.getUser.orgID;
      },
      getYear() {
        if (this.getSelectedYear) return this.getSelectedYear;
        return this.selectedYear;
      },
      isAdmin() {
        return !!this.getUserRoles.find((el) => el === 'ADMIN_ROLE');
      },

      type() {
        return this.$route.query?.type ?? 'BSMA';
      },
      isBlocked() {
        // if (this.isAdmin) return true;
        return this.getBlock[this.type];
      },
      founderId() {

        return this.getSprData.org.find((el) => el.id === this.getOrgId)?.founder?.id ?? null;

      },
      sprData() {
        let sprPredmetTemp = this.getSprData.predmets.filter(
          (el) => el.founderId === this.founderId,
        );
        if (sprPredmetTemp.length === 0)
          sprPredmetTemp = this.getSprData.predmets.filter((el) => el.founderId === null);
        return {
          sprPredmet: Utils.mapSpr(
            sprPredmetTemp,
            'id',
            (el) => el.name,
            (el) => ({ min: el.minScore }),
          ),
        };
      },
      sprDataForDialog() {
        return {
          sprPredmet: this.sprData.sprPredmet.filter((el) => {
            // if ([526, 557, 460].includes(this.getOrgId)) return el.value === 16; ограничения на "славянские" вузы
             return el.value !== 16;
          }),
        };
      },
      kcpId() {
        return Number.parseInt(this.$route.query.idKcp);
      },
      konkursgroupId() {
        return Number.parseInt(this.$route.query.idKonkursgroup);
      },
      getOrgId() {
        return Number.parseInt(this.$route.query.orgId);
      },
    },
    created() {
      this.getOrgTableData();
      this.loadDataTooltip();
    },
    mounted() {
      this.tableHeaders = EgeTableHeaders(this);
    },
    methods: {
      ...mapActions('notifications', { setNotification: 'setNotification' }),
      async loadDataTooltip() {
        let kcpData = {};
        try {
          const res = await request({
            endpoint: `/api/${this.getYear}/data/kcptables/id/${this.kcpId}`,
            method: 'get',
            token: this.getUserAccessToken,
          });
          if (res.status === 200) {
            if (res.data) {
              kcpData = res.data;


            }
          }
        } catch (e) {
          console.log(e);
        }
        let places = {};
        let listSpec = '';
        try {
          const res = await request({
            endpoint: `/api/${this.getYear}/data/places/id/${this.konkursgroupId}`,
            method: 'get',
            token: this.getUserAccessToken,
          });
          if (res.status === 200) {
            if (res.data) {
              places = res.data;
              listSpec = places.prePlacesSpecs.reduce((listSpec, el) => {
                if (listSpec === '') {
                  listSpec = el.specCode + ' - ' + el.specName;
                } else {
                  listSpec += ', ' + el.specCode + ' - ' + el.specName;
                }
                return listSpec;
              }, '');
            }
          }
        } catch (e) {
          console.error(e);
        }
        this.pathTooltip = `<p class="mb-1">Организация: <strong>${kcpData.orgName}</strong></p>
                    <p class="mb-1">Конкурсная группа: <strong>${kcpData.kcpGroupCode} - ${
          kcpData.kcpGroupName
        }</strong></p>
                    <p class="mb-1">Форма финансирования: <strong>${kcpData.ffName}</strong></p>
                    <p class="mb-1">Форма обучения: <strong>${kcpData.foName}</strong></p>
                    <p class="mb-1">Формат конкурса: <strong>${
                      places.manyProfiles ? 'Многопрофильный' : 'Однопрофильный'
                    }</strong></p>
                    <p class="mb-1">Направление(я) подготовки: <strong>${listSpec}</strong></p>
                    <p class="mb-1">Образовательная программа: <strong>${
                      places?.profileName ? places.profileName : 'Нет'
                    }</strong></p>`;
      },

      paintBackgroundProp(row) {
        return () => {
          if (row.sumPlaces !== row.value) return 'yellow-background';
          else return '';
        };
      },

      closeDialog() {
        this.tableData.editRow = null;
        this.minValue = 0;
        this.tableData.change = { value: false, id: null };
        this.tableHeaders = EgeTableHeaders(this);
      },
      async dialogEmits(e) {
        if (e.emits === true) {
          if (e.dataField === 'challengeSubjectBalls') {
            if (e[e.variable] != null) {
              const res = this.$refs.dialog.assignedValuesOneStage;
              let item = [];
              if (res instanceof Promise) {
                await res.then((data) => {
                  item = data;
                });
              } else item = res;
              item =
                item.find((el) => el.dataField === 'challengeSubjectBalls')
                  ?.challengeSubjectBalls ?? [];

              //item = item.find(el => el.dataField === 'challengeSubjectBalls')?.predmets ?? [];
              const bufArr = this.sprData.sprPredmet.filter((el) => item.includes(el.value));

              bufArr.forEach((el) => {
                if (
                  this.tableHeaders.dialog.findIndex((eeIndex) => eeIndex.dopText === el.text) ===
                  -1
                ) {
                  const newRegions = [94, 95, 96, 97].includes(this.getSprData.org.find((el) => el.id === this.getOrgId).region.id)

                  this.tableHeaders.dialog.push(
                    {
                      dopText: el.text,
                      text: 'Минимальные баллы установленные по указанным предметам',
                      dataField: `ballMin-${el.value}`,
                      typeVar: 'integer',
                      rules: 'customRules',
                      dependence: true,
                      dependenceDataField: 'isEge',
                      dependenceValueActive: [true],
                      customsRulesArray: !newRegions ? [
                        (v) =>
                          v >= el.filter.min ||
                          `Значение не может быть меньше минимального кол-ва баллов егэ ${el.filter.min}`,
                        (v) => v != null || v !== 0 || 'Значение должно быть > 0',
                        (v) => v <= 100 || 'Значение должно быть <= 100',
                      ] : [],
                      order: this.tableHeaders.dialog.length + 1,
                    },
                    {
                      text: 'Минимальные баллы для использования особого права',
                      dataField: `ballMinSpecific-${el.value}`,
                      typeVar: 'integer',
                      rules: 'customRules',
                      dependence: true,
                      dependenceDataField: 'isEge',
                      dependenceValueActive: [true],
                      customsRulesArray: !newRegions ? [
                        // v => v >= 75 || `Значение не может быть меньше 75`,
                        // v => (v != null || v != 0) || 'Значение должно быть заполнено',
                        (v) => v <= 100 || 'Значение должно быть <= 100',
                      ] : [],
                      order: this.tableHeaders.dialog.length + 2,
                    },
                  )
                } else {
                  const bufArr = this.tableHeaders.dialog
                    .filter((el2) => el2.dataField.indexOf('-') !== -1)
                    .map((el2) => {
                      const id = Number.parseInt(
                        el2.dataField.slice(el2.dataField.indexOf('-') + 1, el2.dataField.length),
                      );
                      return { ...el2, id: id };
                    });
                  bufArr.forEach((el2) => {
                    if (!item.includes(el2.id)) {
                      const index = this.tableHeaders.dialog.findIndex(
                        (eeIndex) => eeIndex.dataField === el2.dataField,
                      );
                      this.tableHeaders.dialog.splice(index, 1);
                    }
                  });
                }
              });
              this.tableData.editRow = await this.$refs['dialog'].formingObjectToSent();
              this.$refs['dialog'].assignedValuesOneStage = await this.$refs[
                'dialog'
              ].assignDataOneStage([], this.tableHeaders.dialog);
              await this.$refs['dialog'].assignEditData();
            }
          }
        }
      },

      async openDialog(type, row = null) {

        if (type === 'edit') {

          const challengeSubjectBalls = row['challengeSubjectBalls']
            ? row['challengeSubjectBalls'].map((el) => {
                return el.eduSubject.id;
              })
            : [];
          const result = {
            ...row,
            challengeSubjectBalls: challengeSubjectBalls,
          };
          row.challengeSubjectBalls.forEach((el) => {
            result['ballMin-' + el.eduSubject.id] = el.ballMin;
            result['ballMinSpecific-' + el.eduSubject.id] = el.ballMinSpecific;
          });
          this.tableData.editRow = result;
          const item = challengeSubjectBalls; //row?.challengeSubjectBalls.map(el => el.id) ?? [];
          const bufArr = this.sprData.sprPredmet.filter((el) => item.includes(el.value));

          bufArr.forEach((el) => {
            if (
              this.tableHeaders.dialog.findIndex((eeIndex) => eeIndex.dopText === el.name) === -1
            ) {
              const newRegions = [94, 95, 96, 97].includes(this.getSprData.org.find((el) => el.id === this.getOrgId).region.id)
              this.tableHeaders.dialog.push(
                {
                  dopText: el.name,
                  text: 'Минимальные баллы установленные по указанным предметам',
                  dataField: `ballMin-${el.value}`,
                  typeVar: 'integer',
                  rules: 'customRules',
                  dependence: true,
                  dependenceDataField: 'isEge',
                  dependenceValueActive: [true],
                  customsRulesArray: !newRegions ? [
                    (v) =>
                      v >= el.filter.min ||
                      `Значение не может быть меньше минимального кол-ва баллов егэ ${el.filter.min}`,
                    (v) => v != null || v !== 0 || 'Значение должно быть > 0',
                    (v) => v <= 100 || 'Значение должно быть < 100',
                  ] : [],
                  order: this.tableHeaders.dialog.length + 1,
                },
                {
                  text: 'Минимальные баллы для использования особого права',
                  dataField: `ballMinSpecific-${el.value}`,
                  typeVar: 'integer',
                  rules: 'customRules',
                  dependence: true,
                  dependenceDataField: 'isEge',
                  dependenceValueActive: [true],
                  customsRulesArray: !newRegions ? [
                    // v => v >= 75 || `Значение не может быть меньше 75`,
                    // v => (v != null || v != 0) || 'Значение должно быть заполнено',
                    (v) => v <= 100 || 'Значение должно быть <= 100',
                  ] : [],
                  order: this.tableHeaders.dialog.length + 2,
                },
              );
            }
          });
          await this.$refs.dialog.openDialog();
        } else {
          // eslint-disable-next-line no-unused-vars
          const res = this.$refs.dialog.openDialog();
        }
      },

      async changeOrder(type, row) {
          if (type === 'up') {
            row.sortOrder += 1;
          } else if (type === 'down') {
            row.sortOrder -= 1;
          }
          this.tableData.data.sort((a, b) => a.sortOrder - b.sortOrder);
        try {
              await request({
                endpoint: `/api/${this.getYear}/data/challenges`,
                method: 'post',
                body: row,
                token: this.getUserAccessToken,
              });
            } catch (e) {
              console.log(e);
            }
      },
      //как это работает????? и работает ли вообще
      // async changeOrder(type = 'up', row) {
      //
      //   switch (type) {
      //     case 'up': {
      //       this.endpoint = 'up';
      //       break;
      //     }
      //     case 'down': {
      //       this.endpoint = 'down';
      //       break;
      //     }
      //     default: {
      //       this.endpoint = 'up';
      //       break;
      //     }
      //   }
      //   try {
      //     const res = await request({
      //       endpoint: `/api/${this.getYear}/data/challenges/${this.endpoint}`,
      //       method: 'post',
      //       body: row,
      //       token: this.getUserAccessToken,
      //     });
      //     if (res.status === 200) {
      //
      //       await this.getOrgTableData();
      //       console.log(this.tableData.data, "this.tableData.data")
      //
      //     }
      //   } catch (e) {
      //     console.log(e);
      //   }
      // },
      // async loadSprPredmet() {
      //   try {
      //     const res = await request({
      //       endpoint: `/api/spr/predmet`,
      //       method: 'get',
      //       token: this.getUserAccessToken,
      //     });
      //     if (res.status === 200) {
      //       if (res.data) {
      //         this.sprPredmet = res.data;
      //         this.sprData.sprPredmet = Utils.mapSpr(res.data, 'id', (el) => {
      //           return el.name
      //         })
      //       }
      //     }
      //   } catch (e) {
      //     console.log(e);
      //   }
      // },
      async getOrgTableData() {
        this.tableData.loading = true;
        this.tableData.error = null;
        try {
          const res = await getOrgTableDataEge(this.konkursgroupId, this.getId, this.getYear);
          if (res) this.tableData.data = res;
          this.tableData.loading = false;
        } catch (e) {
          this.tableData.error = e;
          this.tableData.loading = false;
        }
      },
      async changeOrgTableData(event) {
        this.tableData.change = { value: true, id: event.id };
        this.tableData.error = null;
        try {
          const otherData = {
            sortOrder: event.id
              ? this.tableData.data.find((el) => event.id === el.id).sortOrder
              : this.tableData.data.length + 1,
            placesTableId: this.konkursgroupId,
            orgId: this.getOrgId,
          };
          const res = await changeOrgTableDataEge(event, otherData, this.getYear);
          if (res) {
            if (event.id) {
              const index = this.tableData.data.findIndex((el) => el.id === event.id);
              this.tableData.data.splice(index, 1, res);
            } else {
              this.tableData.data.push(res);
            }
            this.tableData.data.sort((el, el1) => el.sortOrder - el1.sortOrder);
            this.tableData.change = { value: false, id: event.id };
            await this.$refs.dialog.closeDialog();
          }
          this.tableData.change = { value: false, id: event.id };
        } catch (e) {
          this.tableData.error = e;
          console.error(e);
          this.tableData.change = { value: false, id: event.id };
        }
      },
      async deleteOrgTableData(row) {
        const agree = confirm('Удалить запись?');
        if (agree) {
          this.tableData.change = { value: true, id: row.id };
          try {
            const res = await deleteOrgTableDataEge(row.id, this.getYear);
            if (res) {
              const index = this.tableData.data.findIndex((el) => el.id === row.id);
              this.tableData.data.splice(index, 1);
            }
            this.tableData.change = { value: false, id: row.id };
          } catch (e) {
            console.log('e delete', e);
          }
        }
      },
    },
  };
</script>

<style lang="sass">
  .collapse-mb-0
    .collapse__toggle
      margin-bottom: 0
  .dialog-section
    font-weight: 600
    font-size: 20px
    color: #00559b
    margin-bottom: 12px
</style>
